import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, InputAdornment, FormControl, FormLabel } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import PropTypes from 'prop-types';
import IntegerField from 'src/components/common/IntegerField';
import OperatorSelect from 'src/components/common/OperatorSelect';
import ValidityAdornment from './ValidityAdornment';

const IntegerBoundMassActionField = ({
  classes,
  fieldConfig,
  onChange,
  removeLine,
  removable,
  onOperatorChange,
  isWritable,
  validity,
}) => {
  const { t } = useTranslation();

  return (
    <FormControl required={fieldConfig.model.mandatory}>
      <div className={classes.fieldContainer}>
        <ValidityAdornment validity={validity} />
        <FormLabel
          style={{
            display: 'flex',
            alignItems: 'center',
            fontSize: '0.875rem',
          }}
          component="div"
        >
          {t(`smartmessaging.massAction.filterLabel.${fieldConfig.model.key}`)}
        </FormLabel>
        <div style={{ marginLeft: '16px', marginRight: '16px', display: 'flex' }}>
          <OperatorSelect
            fieldConfig={fieldConfig}
            onChange={onOperatorChange}
            disabled={!isWritable}
          />
        </div>
        <div style={{ width: '100%', display: 'flex' }}>
          <IntegerField
            style={{ flex: '1' }}
            onChange={value => {
              const val = [
                value,
                (fieldConfig.value &&
                  fieldConfig.value.values &&
                  fieldConfig.value.values.length > 1 &&
                  fieldConfig.value.values[1]) ||
                  '',
              ];
              onChange(fieldConfig, val);
            }}
            disabled={!isWritable}
            value={
              (fieldConfig.value &&
                fieldConfig.value.values &&
                fieldConfig.value.values.length &&
                fieldConfig.value.values[0]) ||
              ''
            }
          />
          <InputAdornment position="start">{t('smartmessaging.inputs.AND')}</InputAdornment>
          <IntegerField
            style={{ flex: '1' }}
            onChange={value => {
              const val = [
                (fieldConfig.value &&
                  fieldConfig.value.values &&
                  fieldConfig.value.values.length &&
                  fieldConfig.value.values[0]) ||
                  '',
                value,
              ];
              onChange(fieldConfig, val);
            }}
            disabled={!isWritable}
            value={
              (fieldConfig.value &&
                fieldConfig.value.values &&
                fieldConfig.value.values.length > 1 &&
                fieldConfig.value.values[1]) ||
              ''
            }
          />
          {isWritable && removable && (
            <InputAdornment position="start">
              <IconButton aria-label="clear" onClick={() => removeLine(fieldConfig)} size="large">
                <DeleteIcon />
              </IconButton>
            </InputAdornment>
          )}
        </div>
      </div>
    </FormControl>
  );
};

IntegerBoundMassActionField.propTypes = {
  classes: PropTypes.object.isRequired,
  fieldConfig: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  removeLine: PropTypes.func.isRequired,
  removable: PropTypes.bool.isRequired,
  onOperatorChange: PropTypes.func.isRequired,
  validity: PropTypes.object.isRequired,
  isWritable: PropTypes.bool.isRequired,
};

export default IntegerBoundMassActionField;
